/*jshint unused: false, undef:false */

'use strict';

/**
 * Adapter for Webduct Order Fulfillment Groups
 *
 * @version
 * 12.10.0 MLIBJS-137 Add order and fulfillment group parsing for manufacturing format
 * 12.4.0 #756 MLIBJS-121 Add AdapterFulfillmentGroup into globalThis for ES6 usage
 * 7.3.0 #458 Refactor wdFulfillment, wdStatus (inject helpers)
 *
 * @author Deitric Jang <djang@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2016-2021 Build Centrix
 */
var AdapterFulfillmentGroup = function (wdSharedFunctionsService, wdStatusService) {

    /**
     * Adapter
     *
     * This object is returned.
     *
     * @since 7.3.0
     *
     * @type {*}
     */
    var adapter = {};

    /**
     * Parse Fulfillment Groups from an Order
     *
     * @since 7.3.0
     *
     * @params {Object} fulfillmentGroups List of fulfillment groups from an order to parse
     * @returns {Array} List of parsed fulfillment groups
     */
    adapter.parseFulfillmentGroups = function(fulfillmentGroups) {

        /* jshint camelcase: false */

        var results = [];

        for (var index in fulfillmentGroups) {

            /* istanbul ignore else */
            if (fulfillmentGroups.hasOwnProperty(index)) {

                var newFG = {};

                var fgIndex         = fulfillmentGroups[index].idx;
                var code            = fulfillmentGroups[index].code;
                var fabTimeFloat    = fulfillmentGroups[index].fabrication_time;
                var fabTimeShort    = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(fulfillmentGroups[index].fabrication_time, false);
                var fabTimeLong     = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(fulfillmentGroups[index].fabrication_time, true);
                var label           = fulfillmentGroups[index].label;
                var module          = fulfillmentGroups[index].module;
                var status          = fulfillmentGroups[index].fulfilment_status_idx ? parseInt(fulfillmentGroups[index].fulfilment_status_idx) : newFG.status = parseInt(fulfillmentGroups[index].status);
                var matchingStatus  = wdSharedFunctionsService.getArrayObjectByKey(status, 'index', wdStatusService.statuses);
                var statusDetails   = !wdSharedFunctionsService.isEmptyObject(matchingStatus) ? matchingStatus : null;
                var isSelected      = true;
                var fgItems         = adapter.parseFulfillmentGroupItems(fulfillmentGroups[index].items);
                var isCollapsed     = false;

                newFG.index = fgIndex;
                newFG.code = code;
                newFG.fabrication = {};
                newFG.fabrication.float =  fabTimeFloat;
                newFG.fabrication.short = fabTimeShort;
                newFG.fabrication.long = fabTimeLong;
                newFG.label = label;
                newFG.module = module;
                newFG.status = status;
                newFG.statusDetails = statusDetails;
                newFG.selected = isSelected;
                newFG.items = fgItems;
                newFG.isCollapsed = isCollapsed;

                results.push(newFG);

            }
        }

        results = wdSharedFunctionsService.removeArrayDuplicates(results);
        /* jshint camelcase: true */

        return results;
    };

    /**
     * Parse Fulfillment Groups from an Order (fetched with format=manufacturing)
     *
     * @since 12.10.0
     *
     * @params {Object} fulfillmentGroups List of fulfillment groups from an order (in the 'manfacturing' format) to parse
     * @returns {Array} List of parsed fulfillment groups
     */
    adapter.parseFulfillmentGroupsManufacturing = function(fulfillmentGroups) {

        /* jshint camelcase: false */

        var results = [];

        for (var index in fulfillmentGroups) {

            /* istanbul ignore else */
            if (fulfillmentGroups.hasOwnProperty(index)) {

                var newFG = {};

                var fgIndex         = fulfillmentGroups[index].index;
                var code            = fulfillmentGroups[index].code;
                var fabTimeFloat    = fulfillmentGroups[index].shopLabour ? fulfillmentGroups[index].shopLabour.time.value : 0;
                var fabTimeShort    = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(fabTimeFloat, false);
                var fabTimeLong     = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(fabTimeFloat, true);
                var label           = fulfillmentGroups[index].label;
                var module          = fulfillmentGroups[index].module;      // module (e.g. tracker orders)
                var status          = fulfillmentGroups[index].status.index ? parseInt(fulfillmentGroups[index].status.index) : 0;
                var matchingStatus  = wdSharedFunctionsService.getArrayObjectByKey(status, 'index', wdStatusService.statuses);
                var statusDetails   = !wdSharedFunctionsService.isEmptyObject(matchingStatus) ? matchingStatus : null;
                var isSelected      = true;
                // var fgItems         = adapter.parseFulfillmentGroupItems(fulfillmentGroups[index].items);        // TODO: items not required in calendar so commenting out for now
                var fgItems = [];   // Items don't appear to be used in the calendar and orders in manufacturing format don't include them, so set as empty array
                var isCollapsed     = false;

                newFG.index = fgIndex;
                newFG.code = code;
                newFG.fabrication = {};
                newFG.fabrication.float = fabTimeFloat;
                newFG.fabrication.short = fabTimeShort;
                newFG.fabrication.long = fabTimeLong;
                newFG.label = label;
                newFG.module = module;
                newFG.status = status;
                newFG.statusDetails = statusDetails;
                newFG.selected = isSelected;
                newFG.items = fgItems;
                newFG.isCollapsed = isCollapsed;

                results.push(newFG);
            }
        }

        results = wdSharedFunctionsService.removeArrayDuplicates(results);
        /* jshint camelcase: true */

        return results;
    };

    /**
     * Parse Fulfillment Group Items
     * 
     * @since 7.3.0
     * 
     * @param {{}} items
     * @returns {Array}
     */
    adapter.parseFulfillmentGroupItems = function(items) {

        var results = [];

        for (var item in items) {
            /* istanbul ignore else */
            if (items.hasOwnProperty(item)) {

                /*jshint camelcase: false */
                var targetItem = items[item],
                    assembly = parseInt(targetItem.assembly_order) || 'N/A',
                    itemName = /* istanbul ignore next */ 'N/A',
                    quantity = parseInt(targetItem.quantity) || /* istanbul ignore next */ 'N/A',
                    dimension = adapter.parseDimensions(targetItem.dimension),
                    joint = adapter.parseJoints(targetItem.joint),
                    material = adapter.parseMaterials(targetItem.material),
                    insulation = targetItem.insulation || 'N/A',
                    notes = targetItem.notes || 'N/A',
                    tag = targetItem.tag || 'N/A';
                /*jshint camelcase: true */

                if (targetItem.label) {
                    itemName = targetItem.label;
                } else if (targetItem.labels) {     // tracker items have labels in this format
                    itemName = targetItem.labels.name;
                }

                var result = {
                    assembly: assembly,
                    item: itemName,
                    quantity: quantity,
                    dimension: dimension,
                    joint: joint,
                    material: material,
                    insulation: insulation,
                    notes: notes,
                    tag: tag
                };

                results.push(result);

            }

        }

        return results;
    };

    /**
     * Parse Dimensions for Table
     *
     * @since 7.3.0
     * 
     * @param {{}} dimensions
     * @returns {Array}
     */
    adapter.parseDimensions = function (dimensions) {

        var result = [];

        for (var key in dimensions) {
            /* istanbul ignore else */
            if (dimensions.hasOwnProperty(key)) {

                result.push({
                    key: key,
                    title: dimensions[key].title,
                    value: dimensions[key].value
                });

            }
        }

        return result;

    };

    /**
     * Parse Joints for Table
     *
     * @since 7.3.0
     * 
     * @param {{}} joints
     * @returns {Array}
     */
    adapter.parseJoints = function (joints) {

        var result = [];

        for (var key in joints) {
            /* istanbul ignore else */
            if (joints.hasOwnProperty(key)) {

                result.push({
                    key: key,
                    title: joints[key]
                });

            }
        }

        return result;

    };

    /**
     * Parse Materials for Table
     *
     * @since 7.3.0
     * 
     * @param {{}} materials
     * @returns {Array}
     */
    adapter.parseMaterials = function (materials) {

        var result = [];

        for (var key in materials) {
            /* istanbul ignore else */
            if (materials.hasOwnProperty(key)) {

                result.push({
                    value: materials[key]
                });

            }
        }

        return result;

    };


    return adapter;
};
globalThis.AdapterFulfillmentGroup = AdapterFulfillmentGroup;
// EOF
